import axios from 'axios';

export const upgradeForm = (
    formId: string,
    toastText?: {
        onSuccessText?: string;
        onPendingText?: string;
    }
) =>
    axios
        .post(
            `testapp/form/${formId}/upgrade`,
            {},
            {
                headers: {
                    'Toast-Pending-Text': toastText?.onPendingText,
                    'Toast-Success-Text': toastText?.onSuccessText,
                },
            }
        )
        .then((res) => res.data)
        .catch((error) => {
            throw error;
        });
